const ENV = {
    DEBUG: true,
    APP_ENV: 'local',
    DELAY_INIT: 0,
}
export default ENV;



// WEBPACK FOOTER //
// ./scripts/env.js